module.exports = __webpack_public_path__ + "img/01.37c82ccf.png";